/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class ConfigApi extends runtime.BaseAPI {
    /**
     * Get public Firebase Web client configuration.  Returns the Firebase Web SDK config values needed by browser clients to initialise the Firebase app.  These are public, non-secret values whose access is restricted by Firebase authorized domains and Firestore security rules — it is safe to expose them without authentication.  Returns:     dict: Firebase Web config (apiKey, authDomain, projectId)
     * Get Firebase Config
     */
    async getFirebaseConfigV1ConfigFirebaseGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        let urlPath = `/v1/config/firebase`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get public Firebase Web client configuration.  Returns the Firebase Web SDK config values needed by browser clients to initialise the Firebase app.  These are public, non-secret values whose access is restricted by Firebase authorized domains and Firestore security rules — it is safe to expose them without authentication.  Returns:     dict: Firebase Web config (apiKey, authDomain, projectId)
     * Get Firebase Config
     */
    async getFirebaseConfigV1ConfigFirebaseGet(initOverrides) {
        const response = await this.getFirebaseConfigV1ConfigFirebaseGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get public pricing configuration.  Returns tier information including quotas and prices. This endpoint is public and does not require authentication.  Returns:     dict: Pricing configuration with tiers
     * Get Pricing
     */
    async getPricingV1ConfigPricingGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        let urlPath = `/v1/config/pricing`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get public pricing configuration.  Returns tier information including quotas and prices. This endpoint is public and does not require authentication.  Returns:     dict: Pricing configuration with tiers
     * Get Pricing
     */
    async getPricingV1ConfigPricingGet(initOverrides) {
        const response = await this.getPricingV1ConfigPricingGetRaw(initOverrides);
        return await response.value();
    }
}
